<template>
  <div
    class="tab-content"
    id="infinite-list"
  >
    <div class="input-search">
      <b-form-input
        v-model="computedText"
        :placeholder="$i18nPresenter.t('Search photos from Unsplash..')"
        @input="$emit('searchPhotoUnsplash', 1, false)"
        ref="unsplash-search-input"
        class="w-full"
        name="'StockPhotoSearchInput'"
        v-aha-emit-action
      />
    </div>
    <KeywordSuggestions v-if="canUseKeywordSuggestions" :uploadType="uploadType" :slideOptionId="slideOptionId" />

    <div class="list-image">
      <p v-if="noResultText" class="list-image--no-result">
        {{ noResultText }}
      </p>
      <div
        v-if="splashPhotos.length > 0"
        v-masonry="'masonryStockPhoto'"
        transition-duration="0.5s"
        item-selector=".item-image"
        class="masonry-content"
        ref="masonryStockPhoto"
      >
        <div class="item-image" v-for="(item,index) in splashPhotos" :key="index">
          <div
            class="img-bg"
          >
            <img :src="item.urls.small" @load="onImageLoad" @click="selectImage(item)">
            <div class="img-info">
              Photo by <a
                class="img-info__link"
                :href="'https://unsplash.com/' + item.user.username + '?utm_source=ahaslides&utm_medium=referral'"
                target="_blank"
              >
                {{ item.user.name }}
              </a> on <a
                class="img-info__unsplash-link"
                href="https://unsplash.com/?utm_source=ahaslides&utm_medium=referral"
                target="_blank"
              >
                Unsplash
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Loading
      style="margin: 0 auto; width: 100%;"
      :class="{'hide-loading-image': !isLoadingImg}"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Loading from '@/components/Loading'
import EventBus from '@/eventBus'
import KeywordSuggestions from '@/components/presentations/KeywordSuggestions.vue'

export default {
  components: {
    KeywordSuggestions,
    Loading,
  },
  props: {
    noResultText: {
      type: String,
      default: '',
    },
    splashPhotos: {
      type: Array,
      default: () => [],
    },
    isLoadingImg: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: '',
    },
    uploadType: {
      type: String,
      default: null,
    },
    slideOptionId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      previousSearchText: '',
      noMoreUnsplashResult: false,
    }
  },
  computed: {
    ...mapGetters('featureToggles', ['canUseKeywordSuggestions']),
    computedText: {
      get() {
        return this.text?.trim()
      },
      set(value) {
        this.$emit('update:text', value?.trim())
      },
    },
  },
  destroyed() {
    EventBus.$off('selectedMyPhotoItem')
  },
  methods: {
    onImageLoad() {
      this.$nextTick(() => {
        this.layoutMasonry()
      })
    },
    layoutMasonry() {
      // this.$redrawVueMasonry()
      // this.$refs.masonryContainer1.redrawVueMasonry()
      this.$redrawVueMasonry('masonryStockPhoto')
    },
    selectImage(item) {
      this.$emit('selectImage', 'unsplash', item)
    },
  },
}
</script>
